const map = {
	"./az/cover_az.json": [
		3909,
		[
			909
		]
	],
	"./de/cover_de.json": [
		1069,
		[
			69
		]
	],
	"./fa/cover_fa.json": [
		9521,
		[
			521
		]
	],
	"./fr/cover_fr.json": [
		7271,
		[
			271
		]
	],
	"./nl/cover_nl.json": [
		2487,
		[
			487
		]
	],
	"./ru/cover_ru.json": [
		9081,
		[
			81
		]
	],
	"./sv/cover_sv.json": [
		4325,
		[
			325
		]
	],
	"./ta/cover_ta.json": [
		5637,
		[
			637
		]
	],
	"./tr/cover_tr.json": [
		9779,
		[
			160
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2623;
module.exports = webpackAsyncContext;